"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const GenericImmutableCollection_1 = __importDefault(require("./GenericImmutableCollection"));
/**
 * A collection of objects. This collection allows to get objects by various of
 * its attributes and also indexes the objects on common attributes.
 */
class GenericCollection extends GenericImmutableCollection_1.default {
    constructor(features, attributes) {
        super(features, attributes);
    }
    setFeatures(features) {
        this._features = features;
        this.updateIndexes();
    }
    add(feature) {
        if (this.getFeatureId(feature) && !this.getById(this.getFeatureId(feature))) {
            this._features.push(feature);
            this.updateIndexesForFeature(feature, this.size() - 1);
        }
    }
    getByShortenedId(shortenedId) {
        // (shortened uuid). Will return the first matching feature
        for (let i = 0, count = this._features.length; i < count; i++) {
            if (this.getFeatureId(this._features[i]).startsWith(shortenedId)) {
                return this._features[i];
            }
        }
        return null;
    }
    updateById(featureId, updatedFeature) {
        if (this.getFeatureId(updatedFeature) !== featureId) {
            console.error('the id of the updatedFeature must match the featureId');
        }
        else {
            this.updateFeature(updatedFeature);
        }
    }
    updateFeature(updatedFeature) {
        // TODO Should it not update the indexes? How do we know if one of the indexed field changed?
        const featureId = this.getFeatureId(updatedFeature);
        const featureIndex = this._indexById.get(featureId);
        if (featureIndex !== null && featureIndex !== undefined && featureIndex >= 0) {
            this._features[featureIndex] = updatedFeature;
        }
        else {
            console.error(`trying to update by id but we cannot find the feature (feature id: ${featureId})`);
        }
    }
    removeById(featureId) {
        const featureIndex = this._indexById.get(featureId);
        if (featureIndex !== null && featureIndex !== undefined && featureIndex >= 0) {
            this._features.splice(featureIndex, 1);
            this.updateIndexes();
        }
        else {
            console.error(`trying to remove by id but we cannot find the feature (feature id: ${featureId})`);
        }
    }
    removeByIds(featureIds) {
        let removedFeaturesCount = 0;
        const featureIndexesToRemove = [];
        // we first need to get all indexes, and splice later to keep indexById integrity:
        for (let i = 0, count = featureIds.length; i < count; i++) {
            const featureId = featureIds[i];
            const featureIndex = this._indexById.get(featureId);
            if (featureIndex !== null && featureIndex !== undefined && featureIndex >= 0) {
                featureIndexesToRemove.push(featureIndex);
            }
            else {
                console.error(`trying to remove by id but we cannot find the feature (feature id: ${featureId})`);
            }
        }
        // sort and loop indexes in reverse order so we keep next indexes unchanged:
        featureIndexesToRemove.sort();
        for (let i = featureIndexesToRemove.length - 1; i >= 0; i--) {
            this._features.splice(featureIndexesToRemove[i], 1);
            removedFeaturesCount++;
        }
        if (removedFeaturesCount > 0) {
            this.updateIndexes();
        }
    }
    clear() {
        this.setFeatures([]);
    }
}
exports.default = GenericCollection;
//# sourceMappingURL=GenericCollection.js.map